if (!customElements.get("tab-interface")) {
  class t extends HTMLElement {
    constructor() {
      super(), this.tabs = [], this.firstTab = null, this.lastTab = null, this.activeTab = null;
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll("[role=tab]")), this.tabs.forEach(((t, e) => {
        t.addEventListener("keydown", this.onKeydown.bind(this)), t.addEventListener("click", this.onClick.bind(this)), this.firstTab || (this.firstTab = t, this.activeTab = t), this.lastTab = t, e === this.tabs.length - 1 && this.setSelectedTab(this.activeTab);
      }));
    }

    setSelectedTab(t) {
      this.activeTab = t;
      const e = Array.from(this.querySelectorAll("[role=tabpanel]"));
      this.tabs.forEach(((s, a) => {
        if (e[a] && t && t.getAttribute("aria-controls") === e[a].getAttribute("id")) {
          s.setAttribute("aria-selected", "true"), s.removeAttribute("tabindex"), s.classList.add("active-tab"), void 0 !== e[a] && e[a].classList.contains("is-hidden") && e[a].classList.remove("is-hidden"), e[a].setAttribute("aria-hidden", "false");
          const t = new CustomEvent("tabChange", { detail: { tabpanel: e[a] } });
          this.dispatchEvent(t);
        } else e[a] && (s.setAttribute("aria-selected", "false"), s.classList.remove("active-tab"), s.tabIndex = -1, e[a].classList.add("is-hidden"), e[a].setAttribute("aria-hidden", "true"));
      }));
    }

    moveFocusToTab(t) {
      t.focus();
    }

    moveFocusToPreviousTab(t) {
      let e;
      t === this.firstTab ? this.moveFocusToTab(this.lastTab) : (e = this.tabs.indexOf(t), this.moveFocusToTab(this.tabs[e - 1]));
    }

    moveFocusToNextTab(t) {
      let e;
      t === this.lastTab ? this.moveFocusToTab(this.firstTab) : (e = this.tabs.indexOf(t), this.moveFocusToTab(this.tabs[e + 1]));
    }

    onKeydown(t) {
      var e = t.currentTarget, s = !1;
      switch (t.key) {
        case"ArrowLeft":
          this.moveFocusToPreviousTab(e), s = !0;
          break;
        case"ArrowRight":
          this.moveFocusToNextTab(e), s = !0;
          break;
        case"Home":
          this.moveFocusToTab(this.firstTab), s = !0;
          break;
        case"End":
          this.moveFocusToTab(this.lastTab), s = !0;
      }
      s && (t.stopPropagation(), t.preventDefault());
    }

    onClick(t) {
      this.setSelectedTab(t.currentTarget);
    }
  }

  customElements.define("tab-interface", t);
}